import React from 'react';
import '../../styles/CustomButtonRemove.css';

/**
 * Кастомная кнопка удаления в виде иконки.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {function} props.onClick - Обработчик клика по кнопке.
 * @param {boolean} [props.isDisabled=false] - Отключает кнопку: убирает действие и добавляет CSS-класс `disabled`.
 *
 * @returns {JSX.Element} Элемент кнопки удаления.
 */

function CustomButtonRemove({ onClick, isDisabled }) {
  // Обработчик клика, который проверяет, активна ли кнопка
  const handleRemoveClick = (event) => {
    if (!isDisabled) {
      onClick(event);
    }
    return;
  };
  const buttonClass = `custom-button-remove ${isDisabled ? 'disabled' : ''}`;

  return (
    <div className={buttonClass} onClick={handleRemoveClick}>
      <img src="/image/delete.svg" alt="Remove" className="remove-icon" />
    </div>
  );
}

export default CustomButtonRemove;
